import { Checkbox } from '@etg/wings';
import { forwardRef } from 'react';
import type { ChangeEvent } from 'react';
import { useController, useFormContext } from 'react-hook-form';

interface StopoverCheckboxProps {
  'data-testid'?: string;
  fieldName: string;
  id: string;
  onUpdate: (event: ChangeEvent<HTMLInputElement>) => void;
}

const StopoverCheckbox = forwardRef<HTMLInputElement, StopoverCheckboxProps>(
  ({ 'data-testid': dataTestId, fieldName, id, onUpdate }, ref) => {
    const { control } = useFormContext();
    const {
      field: { onChange, value },
    } = useController({ control, name: fieldName });

    return (
      <Checkbox
        checked={Boolean(value)}
        data-testid={dataTestId}
        id={id}
        name={fieldName}
        onChange={(selectedValue) => {
          onUpdate(selectedValue);
          onChange(selectedValue);
        }}
        ref={ref}
      />
    );
  },
);

StopoverCheckbox.displayName = 'StopoverCheckbox';

export default StopoverCheckbox;
